export const environment = {
  production: false,
  appName: 'MenuDeProdutos',
  env: 'uat',
  clientId: '60467d48dc81cc3acaf74560',
  showMobileModal: true,
  digitalCertificationLoginOption: 'mainframe',
  usePlatformRedirection: false,
  startTourAction: {
    title: 'Tour virtual',
    url: '/',
    queryParams: { starttour: 'force' },
  },
  showNotificationsOnStart: true,
  activateForgotPassword: true,
  siteNetProducts: false,
  useCategoryCookie: true,
  retryPolicyConfig: {
    maxRetryAttempts: 3,
    scalingDuration: 1000,
    urls: [
      {
        url: 'iam/v1',
        methods: ['POST'], // string[]
        statusCodes: [500, 501, 502, 503], // number[]
      },
      {
        url: 'add-event',
        methods: ['POST'], // string[]
        statusCodes: [500, 501, 502, 503], // number[]
      },
      {
        url: 'digital/product-access/v1/my-products',
        methods: ['GET'],
        statusCodes: [500, 501, 502, 503], // number[]
      },
    ],
  },
  activateShowWeakPassword: true,
  iconsSubMenu: {
    products: true,
    loginPortal: true,
    selfService: true,
    invoices: true,
    helpCenter: true
  },
  itemSubMenu: {
    products: true,
    loginPortal: true,
    selfService: true,
    invoices: true,
    helpCenter: true
  },
  urlMonitoring: 'https://serasa-alerta-uat.serasaexperian.com.br',
  PMEProductMenuUrl: '	https://empresas-uat.serasaexperian.com.br/meus-produtos/',
  urlPMEMonitoring: 'https://uat-api.serasaexperian.com.br/credit-services/pme-monitoring/v1',
  serasaAlertaClientId: '61fa8a1971797b45f19a4fa3',
  isAllowMeEnabled: true,
  DATADOG_APPLICATION_ID: '9a18dca6-a830-4cf3-a42d-70bb2833029d',
  DATADOG_CLIENT_TOKEN: 'pub75565abd123079cbd850556f326992f3',
  DATADOG_SERVICE_NAME: 'experian-product-menu-uat',
  DATADOG_CONTEXT_TEAM: 'brazil_digital_paas',
  DATADOG_CONTEXT_COSTSTRING: '1800.br.124.404006',
  DATADOG_CONTEXT_BUSINESSSERVICE: 'authme'
};
